"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _SocialIcon.default;
  }
});
Object.defineProperty(exports, "getSocialIconSlots", {
  enumerable: true,
  get: function () {
    return _SocialIcon.getSocialIconSlots;
  }
});
Object.defineProperty(exports, "iconsMapping", {
  enumerable: true,
  get: function () {
    return _iconsMapping.iconsMapping;
  }
});
Object.defineProperty(exports, "socialIconClasses", {
  enumerable: true,
  get: function () {
    return _socialIconClasses.default;
  }
});
var _SocialIcon = _interopRequireWildcard(require("./SocialIcon"));
var _socialIconClasses = _interopRequireDefault(require("./socialIconClasses"));
var _iconsMapping = require("./iconsMapping");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
//# sourceMappingURL=index.js.map